import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';

const AdminLayout: React.FC = ({ children }) => {
  const { user } = useContext(UserContext);

  if (user.isAdmin) {
    return <div className="flex-auto flex flex-column">{children}</div>;
  }
  return (
    <div className="flex-auto flex items-center justify-center flex-column">
      <div className="bg-white b--light-gray w-100 mw6 pa4 tc">
        <h1 className="display">Access Denied</h1>
        <p className="tan serif i">You need to have admin access to view this area.</p>
      </div>
    </div>
  );
};

export default AdminLayout;
